import React from 'react';
import {useSelector} from 'react-redux';

export const discountRuleDescription = discount => {
  if (!discount) return '';

  if (discount.format === 'fixed_amount') {
    return `$${Number(discount.amount || 0).toFixed(2)} off`;
  }
  if (discount.format === 'family_all') {
    return `${Number(discount.percent || 0)}% off for ${Number(
      discount.minimumMembers || 2
    )} or more family members`;
  }
  if (discount.format === 'family_tiered') {
    const tiers = [...(discount.tiers || [])].sort(
      (left, right) => Number(left.fromMember || 1) - Number(right.fromMember || 1)
    );
    if (!tiers.length) return 'Family member tier discount';

    return tiers
      .map(tier => {
        const memberLabel = `Member ${Number(tier.fromMember || 1)}${tier.openEnded ? '+' : ''}`;
        return `${memberLabel}: ${Number(tier.percent || 0)}% off`;
      })
      .join(', ');
  }

  return `${Number(discount.percent || 0)}% off`;
};

const CouponCodeUI = ({couponCodeLocalState, onCouponCodeChange, _handleValidateCouponCode}) => {
  const bookingDetails = useSelector(state => state.booking);
  const couponDetails = bookingDetails?.couponCode?.couponDetails;
  const currentCode = couponCodeLocalState?.userCode?.trim().toUpperCase();
  const verifiedCode = couponDetails?.coupon?.trim().toUpperCase();
  const currentCodeIsVerified = Boolean(
    currentCode && bookingDetails?.couponCode?.isValid && currentCode === verifiedCode
  );
  const hasExactQuote = Boolean(couponDetails?.quote?.valid);
  const discountDoesNotApply = couponDetails?.quote?.reason === 'DISCOUNT_NOT_APPLICABLE';

  return (
    <div className="confirm-booking-discount-code mt-4">
      <h6>Do you have a discount code?</h6>
      <div className="row mt-2">
        <div className="col-6 col-md-4">
          <input
            type="text"
            className="form-control"
            placeholder="Please enter discount code"
            value={couponCodeLocalState?.userCode || ''}
            onChange={event => onCouponCodeChange(event.target.value)}
          />
        </div>
        <div className="col-6 col-md-4 margin-l-0">
          {couponCodeLocalState?.userCode !== '' && (
            <button
              className="btn btnDefault "
              onClick={_handleValidateCouponCode}
              disabled={couponCodeLocalState?.loading}
            >
              {couponCodeLocalState?.loading ? <i className="fa fa-spinner fa-spin" /> : 'Verify'}
            </button>
          )}
        </div>
      </div>
      {currentCodeIsVerified && discountDoesNotApply && (
        <div className="text-warning mt-2">
          <strong>
            {couponDetails?.applicationSource === 'automatic'
              ? 'Automatic discount recognized:'
              : 'Discount code verified:'}
          </strong>{' '}
          {couponDetails?.title || couponDetails?.coupon}
          <div>{couponDetails?.quote?.message}</div>
        </div>
      )}
      {currentCodeIsVerified && !discountDoesNotApply && (
        <div className="text-success mt-2">
          <strong>{hasExactQuote ? 'Discount applied:' : 'Discount available:'}</strong>{' '}
          {couponDetails?.title || couponDetails?.coupon}
          {discountRuleDescription(couponDetails) && (
            <> — {discountRuleDescription(couponDetails)}</>
          )}
          {!hasExactQuote && <div>Select a package to see the exact discount and final price.</div>}
        </div>
      )}
      {currentCode &&
        bookingDetails?.couponCode?.isValid !== null &&
        !bookingDetails?.couponCode?.isValid && (
          <div className="text-warning mt-2">
            {couponCodeLocalState?.message || 'The code entered is not valid for this order.'}
          </div>
        )}
    </div>
  );
};
export default CouponCodeUI;
